export enum ChallengeDetailsBannerTestIds {
  PLACEHOLDER = 'challenge-banner-details-placeholder',
  ERROR = 'challenge-banner-details-error',
  CHALLENGE = 'challenge-banner-details-challenge',
}
